import React from 'react'
import "./Team.css"
const Team = () => {
  return (
       
<div className="team-section">
  <h1 className="section-title">Our Creative Team</h1>
  <p className="section-subtitle">The talented individuals behind Kajja Galleries' success</p>
  
  <div className="team-grid">
    {/* Team Member 1 */}
    <div className="team-member glass-card">
      <div className="member-image-container">
        <img 
          src="./images/team/kr.PNG" 
          alt="CEO" 
          className="member-image"
          loading="lazy"
        />
        <div className="social-links">
          <a href="#" aria-label="LinkedIn profile"><i className="fab fa-linkedin-in"></i></a>
          <a href="#" aria-label="Twitter profile"><i className="fab fa-twitter"></i></a>
          <a href="#" aria-label="Instagram profile"><i className="fab fa-instagram"></i></a>
        </div>
      </div>
      <div className="member-info">
        <h3>Kajja Ronald</h3>
        <p className="position">CEO & Founder</p>
        <p className="bio">With 10+ years in interior design, Kajja brings visionary concepts to life.</p>
      </div>
    </div>

    {/* Team Member 4 */}
    <div className="team-member glass-card">
      <div className="member-image-container">
        <img 
          src="./images/team/hope.JPG" 
          alt="Asiimwe Hope" 
          className="member-image"
          loading="lazy"
        />
        <div className="social-links">
          <a href="#" aria-label="LinkedIn profile"><i className="fab fa-linkedin-in"></i></a>
          <a href="#" aria-label="Twitter profile"><i className="fab fa-twitter"></i></a>
          <a href="#" aria-label="Instagram profile"><i className="fab fa-instagram"></i></a>
        </div>
      </div>
      <div className="member-info">
        <h3>Asiimwe Hope Amutuhaire</h3>
        <p className="position">Manager</p>
        <p className="bio">As Manager Kajja Galleries, Hope brings a strategic vision and leadership edge to every campaign. With a proven track record of building brands, driving growth, and forging strong customer connections.</p>
      </div>
    </div> 

    {/* Team Member 2 */}
    <div className="team-member glass-card">
      <div className="member-image-container">
        <img 
          src="./images/team/sarahdesignerfinaledit.JPG" 
          alt="Sarah - Lead Designer" 
          className="member-image"
          loading="lazy"
        />
        <div className="social-links">
          <a href="#" aria-label="LinkedIn profile"><i className="fab fa-linkedin-in"></i></a>
          <a href="#" aria-label="Twitter profile"><i className="fab fa-twitter"></i></a>
          <a href="#" aria-label="Instagram profile"><i className="fab fa-instagram"></i></a>
        </div>
      </div>
      <div className="member-info">
        <h3>Nakabojja Sarah</h3>
        <p className="position"> Lead Designer</p>
        <p className="bio">With 5+ years of experience, specializing in sustainable materials and innovative spatial solutions that merge functionality with modern design.+</p>
      </div>
    </div>

    {/* Team Member 3 */}
    <div className="team-member glass-card">
      <div className="member-image-container">
        <img 
          src="./images/team/sumayiya.jpeg" 
          alt="Accountant" 
          className="member-image"
          loading="lazy"
        />
        <div className="social-links">
          <a href="#" aria-label="LinkedIn profile"><i className="fab fa-linkedin-in"></i></a>
          <a href="#" aria-label="Twitter profile"><i className="fab fa-twitter"></i></a>
          <a href="#" aria-label="Instagram profile"><i className="fab fa-instagram"></i></a>
        </div>
      </div>
      <div className="member-info">
        <h3>Muwebwa Sumaiyah</h3>
        <p className="position">Accountant</p>
        <p className="bio">With over 3 years of experience, Sumaiyah is a Kampala-based accountant responsible for both financial management and cost-control functions, delivering tailored financial solutions to meet client and organizational needs.</p>
      </div>
    </div>
     <div className="team-member glass-card">
      <div className="member-image-container">
        <img 
          src="./images/team/tina.jpg" 
          alt="Christine Nangendo" 
          className="member-image"
          loading="lazy"
        />
        <div className="social-links">
          <a href="#" aria-label="LinkedIn profile"><i className="fab fa-linkedin-in"></i></a>
          <a href="#" aria-label="Twitter profile"><i className="fab fa-twitter"></i></a>
          <a href="#" aria-label="Instagram profile"><i className="fab fa-instagram"></i></a>
        </div>
      </div>
      <div className="member-info">
        <h3>Christine Nangendo</h3>
        <p className="position">Head Quality Control</p>
        <p className="bio">
        As Head of Quality Control at Kajja Galeries, she is committed to maintaining the highest standards across all gallery operations. She oversees quality assurance processes to ensure every artwork, exhibition, and client experience reflects the professionalism and creativity that define Kajja Galleries.
        </p>
      </div>
    </div> 
    <div className="team-member glass-card">
      <div className="member-image-container">
        <img 
          src="./images/team/gashome.jpeg" 
          alt="Gashome" 
          className="member-image"
          loading="lazy"
        />
        <div className="social-links">
          <a href="#" aria-label="LinkedIn profile"><i className="fab fa-linkedin-in"></i></a>
          <a href="#" aria-label="Twitter profile"><i className="fab fa-twitter"></i></a>
          <a href="#" aria-label="Instagram profile"><i className="fab fa-instagram"></i></a>
        </div>
      </div>
      <div className="member-info">
        <h3>Kabali Gashome</h3>
        <p className="position">Designer</p>
        <p className="bio"> A Kampala-based Product Designer crafting user-centered designs that enhance product functionality and user experience.</p>
      </div>
    </div> 
    
  </div>
</div>
  )
}

export default Team
